<template>

  <div class="bill-filter">
     <b-row class="mb-4"
      > <b-col cols="3"
        >
        <div class="date-style">
           <b-input-group
            > <date-picker
              placeholder="Từ"
              class="form-control form-control-sm"
              :config="dpConfigs.date"
              v-model="apiParams.fromDate"
            ></date-picker
            > </b-input-group
          > <span class="ml-1 mr-1"></span> <b-input-group
            > <date-picker
              placeholder="Đến"
              class="form-control form-control-sm"
              :config="dpConfigs.date"
              v-model="apiParams.toDate"
            ></date-picker
            > </b-input-group
          >
        </div>
         </b-col
      > <b-col cols="3"
        > <BDropdownCustom
          v-model="apiParams.storeIds"
          :options="optionStores"
          :placeholder="'cửa hàng'"
          :searchable="true"
          :matchKey="['name', 'shortName']"
          :limit="10"
        /> </b-col
      > <b-col cols="3" v-if="!isWholesale"
        > <Autosuggest
          :model="apiParams.customerPhoneSearch"
          :suggestions="optionsCustomerPhone"
          :suggestionName="'phoneNo'"
          :placeholder="'sđt khách hàng'"
          :limit="10"
          @select="onSelectedCustomerPhone"
          @change="onChangeCustomerPhone"
          > <template #custom="{ suggestion }"
            >
            <div class="d-flex flex-column">
               <span
                class="text-primary mb-1"
                v-if="suggestion.item.phoneNo"
                >({{ suggestion.item.phoneNo }})</span
              > <span>{{ suggestion.item.fullName }}</span
              >
            </div>
             </template
          > </Autosuggest
        > </b-col
      > <b-col cols="3" v-if="isWholesale"
        > <b-input
          id="customer-name-search-input"
          v-model="apiParams.customerNameSearch"
          placeholder="Nhập tên khách hàng / công ty"
          autocomplete="off"
          size="sm"
          @keyup.enter="onCustomerNameSearchEnter"
        /> </b-col
      > <b-col cols="3"
        > <Autosuggest
          :model="apiParams.employeeName"
          :suggestions="optionsEmployee"
          :suggestionName="'suggestionName'"
          :placeholder="isWholesale ? 'nhân viên kinh doanh' : 'nhân viên bán hàng'"
          :limit="100"
          @select="onSelected($event, 'Employee')"
          @change="onInputed($event, 'Employee')"
          > <template #custom="{ suggestion }"> {{ suggestion.item.suggestionName }} </template>
          </Autosuggest
        > </b-col
      > </b-row
    > <b-row class="mb-4"
      > <b-col cols="3"
        > <b-input
          placeholder="Nhập tên sản phẩm (tối thiểu 3 ký tự)"
          v-model="apiParams.productSearch"
          autocomplete="off"
          size="sm"
        /> </b-col
      > <b-col cols="3"
        > <b-input
          placeholder="Nhập mã IMEI"
          v-model="apiParams.imeiSearch"
          autocomplete="off"
          size="sm"
        /> </b-col
      > <b-col cols="3"
        > <b-input
          placeholder="Mã coupon"
          v-model="apiParams.searchCoupon"
          size="sm"
        ></b-input
        > </b-col
      > <b-col cols="3"
        > <BDropdownCustom
          v-model="apiParams.criteriaIds"
          :options="optionCriterias"
          :placeholder="'đặc điểm'"
          :searchable="true"
          :matchKey="['name']"
          :limit="20"
        /> </b-col
      > </b-row
    > <b-row class="mb-4"
      > <b-col cols="3"
        > <b-input
          placeholder="Nhập ID hóa đơn"
          v-model="apiParams.billId"
          size="sm"
          autocomplete="off"
          v-focus
        ></b-input
        > </b-col
      > <b-col cols="3"
        > <b-input
          placeholder="Nhập ID đơn hàng"
          v-model="apiParams.orderId"
          size="sm"
          autocomplete="off"
          v-focus
        ></b-input
        > </b-col
      > <b-col cols="3"
        > <b-input
          placeholder="Nhập ghi chú hóa đơn"
          v-model="apiParams.billNote"
          autocomplete="off"
          size="sm"
        /> </b-col
      > <b-col cols="3"
        > <b-input
          placeholder="Nhập ghi chú bán hàng"
          v-model="apiParams.saleNote"
          autocomplete="off"
          size="sm"
        />
      </b-col>
    </b-row>
    <b-collapse id="bill-advanced-search" class="mt-2 mb-2">
      <b-row class="mb-4">
        <b-col cols="3">
          <b-input
            placeholder="Mã đơn sàn"
            v-model="apiParams.externalOrderIdSearch"
            autocomplete="off"
            size="sm"
          />
        </b-col>
        <b-col cols="3">
          <b-input
            placeholder="Mã vận đơn"
            v-model="apiParams.orderCodeShip"
            autocomplete="off"
            size="sm"
          />
        </b-col>
        <b-col cols="3">
          <BDropdownCustom
            v-model="apiParams.installmentUnitIds"
            :options="optionInstallments"
            :placeholder="'dịch vụ trả góp'"
            :searchable="true"
            :matchKey="['name']"
          />
        </b-col>
        <b-col cols="3">
          <Autosuggest
            :model="selectedCreditAcc"
            :suggestions="filteredCreditAccOptions"
            placeholder="tài khoản quẹt thẻ"
            :limit="10"
            @select="onCreditAccSelected"
            @change="onInputCreditAccChange"
          />
        </b-col>
      </b-row>
    </b-collapse>
    <b-row class="mb-4">
      <b-col cols="6">
        <div class="einvoice-filter-group">
          <span class="einvoice-filter-label">HĐĐT:</span>

          <div class="einvoice-segment-control">
            <button
              type="button"
              class="segment-btn"
              :class="{ 'is-active': apiParams.hasEInvoice === null }"
              @click="setEInvoiceFilter(null)"
            >
              Tất cả
            </button>

            <button
              type="button"
              class="segment-btn segment-btn--has"
              :class="{ 'is-active': apiParams.hasEInvoice === true }"
              @click="setEInvoiceFilter(true)"
            >
              <i class="fas fa-file-invoice mr-1"></i>
              Có HĐĐT
            </button>

            <button
              type="button"
              class="segment-btn segment-btn--none"
              :class="{ 'is-active': apiParams.hasEInvoice === false }"
              @click="setEInvoiceFilter(false)"
            >
              <i class="fas fa-file-circle-question mr-1"></i>
              Chưa có
            </button>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row class="mb-4">
      <b-col>
        <b-button-group size="sm">
          <b-button
            style="width: 70px"
            class="font-weight-bolder"
            variant="primary"
            @click="onFilter"
            ><i class="fas fa-search text-white fa-lg"></i>Lọc</b-button
          >
          <b-button
            variant="primary"
            v-b-toggle.bill-advanced-search
            class="togge-filter"
            aria-label="Mở rộng bộ lọc nâng cao"
          >
            <i class="fas fa-angle-down toggle-filter-icon"></i>
          </b-button>
          </b-button-group
        > </b-col
      > </b-row
    >
  </div>

</template>

<script>
  import BDropdownCustom from '@/view/base/bootstrap/BDropdownCustom.vue'
  import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue'
  import timeUtils from '@/utils/date'
  import apiCommonMixin from '@/view/mixins/api-common.mixins.js'
  import { cloneDeep } from 'lodash'
  import ApiService from '@/core/services/api.service'
  import { removeAccents, makeToastFaile } from '@/utils/common'
  import { TIME_TRIGGER, CRITERIA } from '@/utils/constants'
  import {
    BILL_TYPE,
    CRITERIA_FILTER_BILL,
    ACCOUNTANT_TYPE,
    CUSTOMER_STATUS,
  } from '@/utils/enum'
  import decounce from 'debounce'

  export default {
    mixins: [apiCommonMixin],
    name: 'BillFilter',
    components: {
      BDropdownCustom,
      Autosuggest,
    },
    props: {
      billType: {
        type: Number,
        default: null,
      },
    },
    data() {
      return {
        apiParams: {
          fromDate: timeUtils.getSubtractDate(15),
          toDate: '',
          storeIds: [],
          criteriaIds: [],
          productSearch: '',
          imeiSearch: '',
          searchCoupon: '',
          employeeName: '',
          billId: '',
          orderId: '',
          customerPhoneSearch: '',
          customerNameSearch: '',
          contractCodeSearch: '',
          serialNumberSearch: '',
          billNote: '',
          saleNote: '',
          externalOrderIdSearch: '',
          orderCodeShip: '',
          hasEInvoice: null,
          installmentUnitIds: [],
          creditUnitIds: [],
        },
        dpConfigs: timeUtils.DP_CONFIG,
        filteredEmployees: [],
        optionOrigin: {
          employees: [],
          stores: [],
        },
        optionStores: [],
        filteredOptionsCustomerPhone: [],
        isSearchingCustomerPhone: false,
        optionCriterias: CRITERIA,
        optionInstallments: [],
        optionCreditAccounts: [],
        selectedCreditAcc: '',
        filteredCreditAccOptions: [],
        creditAccOptions: [{ data: [] }],
      }
    },
    computed: {
      isShippingBillList() {
        return this.billType === BILL_TYPE.SHIPPING
      },
      isWholesale() {
        return this.billType === BILL_TYPE.WHOLESALE_INVOICE
      },
      optionsEmployee() {
        return cloneDeep(this.filteredEmployees)
      },
      optionsCustomerPhone() {
        return cloneDeep(this.filteredOptionsCustomerPhone)
      },
    },
    watch: {
      $props: {
        handler() {},
        deep: true,
        immediate: true,
      },
      apiParams: {
        handler(newVal) {
          this.$emit('update-filter', newVal)
        },
        deep: true,
        immediate: false,
      },
    },
    async created() {
      this.initCriteriaOptions()
      await Promise.all([
        this.fetchEmployee(),
        this.fetchInstallments(),
        this.fetchCreditAccounts(),
      ])
      const { stores, currentStoreId, currentStoreName } = await this.fetchStoreByUser()
      this.optionStores = stores
      this.optionOrigin.stores = stores
      if (currentStoreId) {
        const currentStore = {
          id: currentStoreId,
          name: currentStoreName,
        }
        this.apiParams.storeIds = [currentStore]
      }
      this.onFilter()
    },
    mounted() {
      window.addEventListener('keyup', this.onFilterKeyEnter)
    },
    beforeDestroy() {
      window.removeEventListener('keyup', this.onFilterKeyEnter)
    },
    methods: {
      initCriteriaOptions() {
        const opts = cloneDeep(CRITERIA)
        if (this.isShippingBillList) {
          opts.push(
            {
              id: CRITERIA_FILTER_BILL.ORDER_FROM_SHOPEE,
              name: 'Đơn từ Shopee',
              checked: false,
            },
            {
              id: CRITERIA_FILTER_BILL.ORDER_FROM_APP,
              name: 'Đơn từ app (không Shopee)',
              checked: false,
            },
          )
        }
        this.optionCriterias = opts
      },
      onFilterKeyEnter(event) {
        if (event.key !== 'Enter') return
        if (event.target?.id === 'customer-name-search-input') return
        this.onFilter()
      },
      validateCustomerNameSearch() {
        const text = (this.apiParams.customerNameSearch || '').trim()
        if (!text) return true
        if (text.length < 3) {
          makeToastFaile('Vui lòng nhập tên khách hàng tối thiểu 3 ký tự')
          return false
        }
        return true
      },
      onCustomerNameSearchEnter() {
        if (!this.validateCustomerNameSearch()) return
        this.onFilter()
      },
      fitlerOptionsBy(items, textInput, prop, limit) {
        return cloneDeep(items)
          .filter((item) => {
            if (item) {
              const nameWTUnicode = removeAccents(item[prop] || '')
              const nameInputWTUnicode = removeAccents(textInput)
              const index = nameWTUnicode.toLowerCase().indexOf(nameInputWTUnicode.toLowerCase())

              if (index > -1) {
                return true
              }
            }
            return false
          })
          .slice(0, limit)
      },
      onSelected(option, type) {
        switch (type) {
          case 'Employee':
            this.apiParams.employeeId = option.item.id
            break
          default:
            break
        }
      },
      onInputed(textInput = '', type) {
        switch (type) {
          case 'Employee':
            this.apiParams.employeeId = null
            this.filteredEmployees = this.fitlerOptionsBy(
              this.optionOrigin.employees,
              textInput,
              'suggestionName',
              10,
            )
            if (this.filteredEmployees.length === 1) {
              this.apiParams.employeeId = this.filteredEmployees[0].id
            }
            break
          default:
            break
        }
      },
      async fetchInstallments() {
        const res = await ApiService.query('v1/installments', { params: { page: 1, pageSize: 1000 } })
        const items = res.data?.data?.result || []
        this.optionInstallments = items.map((item) => ({ id: item.id, name: item.name }))
      },
      async fetchCreditAccounts() {
        const res = await ApiService.query('accountants/getByType', { params: { type: ACCOUNTANT_TYPE.CREDIT, pageSize: 1000 } })
        const raw = res.data?.data
        const items = Array.isArray(raw) ? raw : []
        const mapped = items
          .filter((item) => item.level >= 2)
          .map((item) => ({ id: item.id, name: item.name }))
        this.optionCreditAccounts = mapped
        this.creditAccOptions = [{ data: mapped }]
        this.filteredCreditAccOptions = [...mapped]
      },
      fetchEmployee() {
        ApiService.get('v1/employees/all').then((data) => {
          const employees = data.data.data
          const employeesData = employees.map((element) => {
            return {
              id: element.id,
              name: element.fullName,
              suggestionName: element.fullName,
            }
          })
          this.optionOrigin.employees = employeesData
          this.filteredEmployees = employeesData
        })
      },
      searchCustomer() {
        const searchText = this.apiParams.customerPhoneSearch
        this.isSearchingCustomerPhone = true
        this.filteredOptionsCustomerPhone = []

        ApiService.get(
          `v1/customers/get-by-phone?phoneNumber=${searchText}&customerStatus=${CUSTOMER_STATUS.ACTIVE}`,
        ).then((data) => {
          const customers = data.data.data
          this.filteredOptionsCustomerPhone = customers || []
          this.isSearchingCustomerPhone = false
        })
      },
      debounceSearchCustomerPhone: decounce(function () {
        if (!this.isSearchingCustomerPhone) {
          this.searchCustomer()
        }
      }, TIME_TRIGGER),
      onChangeCustomerPhone(textInput) {
        const searchText = textInput ? textInput.trim() : null
        this.apiParams.customerPhoneSearch = searchText
        this.debounceSearchCustomerPhone()
      },
      onSelectedCustomerPhone(option) {
        if (!option) return
        this.apiParams.customerPhoneSearch = option.item.phoneNo
      },
      getSuggestionCustomerPhoneValue(suggestion) {
        return suggestion.item.phoneNo
      },
      onCreditAccSelected(option) {
        this.selectedCreditAcc = option.item.name
        this.apiParams.creditUnitIds = option.item.id ? [option.item] : []
      },
      onInputCreditAccChange(text) {
        this.selectedCreditAcc = text
        this.apiParams.creditUnitIds = []
        const filteredData = this.creditAccOptions[0].data
          .filter((item) =>
            removeAccents(item.name).toLowerCase().indexOf(removeAccents(text || '').toLowerCase()) > -1
          )
          .slice(0, 10)
        this.filteredCreditAccOptions = [...filteredData]
      },
      onFilter() {
        if (this.isWholesale && !this.validateCustomerNameSearch()) return
        this.$emit('filter', this.apiParams)
      },
    setEInvoiceFilter(value) {
      this.apiParams.hasEInvoice = value;
    },
  },
}
</script>

<style lang="scss">
  .bill-filter {
  .checkbox-style {
    position: absolute;
    right: 0.7vw;
  }

  .custom-card-body {
    padding: 0 2.25rem;
  }

  .date-style {
    display: flex;
    align-items: center;
  }

  .select-style {
    border-radius: 0.28rem;
    box-shadow: none;
    border: 1px solid #ced4da;
  }

  input.form-control {
    border: 1px solid #ced4da;
  }

  .multiselect__tags {
    height: calc(1.35em + 1.1rem + 2px);
    display: block;
    border-radius: 0.28rem;
    border: 1px solid #ced4da;
    font-size: 0.925rem;
    min-height: initial;
    padding-top: 0.3rem;
  }

  .multiselect__select {
    width: 3rem;
    height: 2.5rem;
    top: 0.1rem;
  }

  .multiselect__placeholder {
    color: #495057;
    padding-left: 0.2rem;
  }

  .multiselect__element {
    font-size: 0.925rem;
  }

  .multiselect__input {
    padding-top: 0.2rem;
    font-size: 0.925rem;
  }

  .multiselect__single {
    font-size: 0.925rem;
    line-height: 1.9;
    padding-left: 0.2rem;
    display: inline-block;
    max-width: 100%;
  }

  .autosuggest__results {
    position: absolute;
    width: 100%;
    max-height: 200px;
    z-index: 999;
    border: 1px solid #e0e0e0;
    overflow-y: scroll;
    overflow-x: hidden;
    background-color: #fff;
  }

  .autosuggest__results-container {
    position: relative;
    width: 100%;
  }

  .autosuggest__input {
    display: block;
    width: 100%;
    height: calc(1.35em + 1.1rem + 2px);
    line-height: 1.35;
    padding: 0.55rem 0.75rem;
    font-weight: 400;
    font-size: 0.925rem;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.28rem;
    transition:
      border-color 0.15s ease-in-out,
      box-shadow 0.15s ease-in-out;
  }

  .autosuggest__input:focus {
    outline: none !important;
    border: 1px solid #92c5f9;
  }

  .autosuggest__results-item:hover {
    background-color: #ddd;
  }

  .autosuggest__results ul li {
    padding: 8px;
  }
  #autosuggest {
    width: 100%;
  }

  .wizard.wizard-4 .wizard-nav .wizard-steps .wizard-step {
    flex: 0 0 calc(11% - 0.25rem);
    background-color: #f0f1f9;
  }

  .wizard.wizard-4
    .wizard-nav
    .wizard-steps
    .wizard-step[data-wizard-state='current'] {
    background-color: #ffffff;
  }

  @media (max-width: 1399.98px) {
    .wizard.wizard-4 .wizard-nav .wizard-steps .wizard-step {
      flex: 0 0 calc(17% - 0.25rem);
    }
  }

  .wizard-nav-bg {
    background-color: #f7f7f7;
    border-radius: 5px 5px 0px 0px;
  }

  .collapsing {
    -webkit-transition: none;
    transition: none;
    display: none;
  }
  .togge-filter {
    background-color: #3d8cdd;
    border-color: #3d8cdd;
  }

  .toggle-filter-icon {
    display: inline-block;
    transition: transform 0.2s ease;
  }

  .togge-filter[aria-expanded='true'] .toggle-filter-icon {
    transform: rotate(180deg);
  }

  .vue-treeselect__input-container {
    padding-top: 0px;
  }

  .vue-treeselect__control {
    border-radius: 0.28rem;
    border: 1px solid #ced4da;
    height: 2.5rem;
  }

  // ─── E-Invoice Filter ─────────────────────────────────────────
  .einvoice-filter-group {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    flex-wrap: wrap;
  }

  .einvoice-filter-label {
    font-size: 0.875rem;
    font-weight: 600;
    color: #495057;
    white-space: nowrap;
  }

  // Segment Control (Pill Toggle)
  .einvoice-segment-control {
    display: inline-flex;
    background: #f1f3f5;
    border-radius: 6px;
    padding: 3px;
    gap: 2px;
  }

  .segment-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 6px 12px;
    border: none;
    border-radius: 4px;
    background: transparent;
    font-size: 12px;
    font-weight: 500;
    color: #495057;
    cursor: pointer;
    transition: all 0.15s ease;
    white-space: nowrap;

    &:hover:not(.is-active) {
      background: #e9ecef;
    }

    &:focus {
      outline: none;
      box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.25);
    }

    i {
      font-size: 11px;
    }

    // Active state - default (All)
    &.is-active {
      background: #fff;
      color: #212529;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    }
  }

  // "Có HĐĐT" variant - green tint when active
  .segment-btn--has.is-active {
    background: #d3f9d8;
    color: #2b8a3e;
    box-shadow: none;
  }

  // "Chưa có" variant - amber tint when active
  .segment-btn--none.is-active {
    background: #fff9db;
    color: #e67700;
    box-shadow: none;
  }
}
</style>
